<template>
  <div class="homePage">
    <div>
      <Header @childEvent="handleChild"></Header>
      <div style="width: 100%">
        <div class="SwiperContent" style="width: 100%">
          <swiper :options="swiperOption">
            <!-- <swiper-slide class="swiper-slide"
              ><img
                src="../assets/images/loveActivity.png"
                alt=""
                data-url="https://www.smith-nephew.com/en-us/Wimbledon"
                style="width: 100%; cursor: pointer"
              />
            </swiper-slide> -->
            <swiper-slide class="swiper-slide"
              ><img
                src="../assets/images/phonecustom.png"
                alt=""
                data-url="http://weclientent.smith-nephew.com.cn/AnnualMeeting/Modules/questionnaire/wenjuan.aspx"
                style="width: 100%; cursor: pointer"
              />
            </swiper-slide>
            <swiper-slide class="swiper-slide"
              ><img
                src="../assets/images/aftersaleservice.png"
                alt=""
                style="width: 100%; cursor: pointer"
              />
            </swiper-slide>
            <!-- <swiper-slide class="swiper-slide"
              ><img
                src="../assets/images/loveActivity1.png"
                alt=""
                style="width: 100%; cursor: pointer"
              />
            </swiper-slide> -->
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <!-- <el-carousel
            height="73vh"
            direction="horizontal"
            :autoplay="false"
            arrow="never"
            ref="carousel"
            @change="changeCarousel"
          >
            <el-carousel-item name="1">
              <img
                src="../assets/images/aftersaleservice.png"
                alt=""
                data-url="/userManual"
                style="width: 100%; cursor: pointer"
              />
            </el-carousel-item>
            <el-carousel-item name="2"
              ><img
                src="../assets/images/phonecustom.png"
                alt=""
                data-url="/Questionnaire"
                style="width: 100%; cursor: pointer"
                @click="setActiveItem(1)"
              />
            </el-carousel-item>
          </el-carousel> -->
        </div>
      </div>
    </div>
    <Footer @childEvent="handleChild"></Footer>
    <van-popup v-model="show" position="bottom" class="popShow">
      <div class="popContent">
        <div class="btnTitle">
          <van-button
            icon="cross"
            type="info"
            color="#00729c"
            class="btnCross"
            size="small"
            plain
            @click="gotoEnglish('no')"
          ></van-button>
        </div>
        <div class="text-block">
          <div class="paragraphs">
            <p>
              您拟打开另一个国家或司法管辖区的施乐辉网站。如果您继续打开该网站，您使用该网站的行为将受该网站使用条款和隐私声明的约束。该网站上展示的产品可能无法在您所在的区域提供。如果您对您所在区域的产品供应情况有疑问，请联系您的施乐辉代表。如果您继续访问该网站，即表示您承认并同意本声明的内容。您确定要离开本网站吗？
            </p>
          </div>
          <div class="btnGroup">
            <van-button
              type="info"
              color="#00729c"
              size="large"
              @click="gotoEnglish('yes')"
              >是</van-button
            >
            <van-button
              class="NoBtn"
              color="#00729c"
              size="large"
              plain
              @click="gotoEnglish('no')"
              >否</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Footer from "../components/FooterNav.vue";
import Header from "../components/HeaderNav.vue";
export default {
  components: {
    Footer,
    Header,
    show: false,
  },
  name: "homePage",
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          elay: 3000,
          stopOnLastSlide: false,
          isableOnInteraction: false,
          disableOnInteraction: false,
        },
        //滑动速度
        speed: 2000,
        // 如果需要分页器
        observer: true, //监听，当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper。
        pagination: {
          el: ".swiper-pagination",
          bulletActiveClass: "my-swiper-active",
          clickable: true,
        },
        observeParents: true, //修改swiper的父元素时，自动初始化swiper  如果修改外层样式，这个一定要加！！
        on: {
          click(e) {
            var url = e.target.dataset.url;
            if (url) {
              // window.open(
              //   "http://weclientent.smith-nephew.com.cn/AnnualMeeting/Modules/questionnaire/wenjuan.aspx"
              // );
              window.open(url);
              // let path = "";
              // if (url.indexOf("Questionnaire") != -1) {
              //   path = url + "?type=post&id=787";
              // } else {
              //   path = url;
              // }
              // this.$router.push({
              //   path: path,
              // });
            }
          },
        },
      },
      show: false,
    };
  },
  created() {
    window.scroll(0, 0);
  },
  methods: {
    // 处理头子组件
    handleChild(val) {
      console.log(val);
      this.show = val;
    },
    gotoEnglish(val) {
      if (val == "yes") {
        window.open("https://www.smith-nephew.com");
      } else {
        this.show = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.homePage {
  min-width: 375px;
  max-width: 1920px;
  min-height: 100vh;
  margin: 0 auto;
  .SwiperContent {
    margin: 0 auto 20px;
    ::v-deep .swiper-pagination {
      position: relative;
      bottom: 0px;
    }
    ::v-deep .swiper-pagination-bullet {
      width: 60px;
      height: 5px;
      background: #7fb8cd;
      opacity: 1;
      border-radius: 10px;
    }
    ::v-deep .my-swiper-active {
      width: 100px;
      height: 5px;
      // background: #7fb8cd;
      background: #00719c;
      opacity: 1;
      border-radius: 10px;
    }
  }
  .popShow {
    max-height: 100vh;
    @media (max-width: 1000px) {
      padding: 10px 0 20px;
    }
    @media (min-width: 1024px) {
      // width: calc(100% - 288px);
      padding: 28px 0;
    }
    @media (min-width: 1680px) {
      padding: 28px 0 62px;
    }
    .popContent {
      max-width: 1920px;

      @media (max-width: 1000px) {
        padding: 0 28px;
      }
      @media (min-width: 1024px) {
        padding: 0 56px;
      }
      @media (min-width: 1680px) {
        padding: 0 288px;
      }
    }
    .btnTitle {
      text-align: end;
      margin: 10px 0;
      .btnCross {
        border-radius: 8px;
        border-width: 2px;
        font-size: 18px;
        line-height: 20px;
        font-weight: 600;
        width: 40px;
        height: 40px;
        @media (max-width: 767px) {
          width: 35px;
          height: 35px;
          line-height: 18px;
        }
      }
    }
    .text-block {
      @media (min-width: 1000px) {
        width: 90%;
      }
      .paragraphs {
        @media (min-width: 767px) {
          margin: 30px auto 20px;
        }
        @media (max-width: 767px) {
          margin: 29px auto 10px;
        }
        p {
          font-family: "SNEmericWeb_Book";
          text-align: justify;
          @media (min-width: 767px) {
            font-size: 14px;
          }
          @media (max-width: 767px) {
            font-size: 13px;
          }
          line-height: 2;
        }
      }
      .btnGroup {
        @media (min-width: 767px) {
          display: flex;
          align-items: center;
          width: 68.5%;
        }
        .van-button {
          font-family: "SNEmericWeb_SemiBold";
          border-radius: 8px;
          @media (min-width: 767px) {
            height: 49px;
          }
        }
        .NoBtn {
          border-width: 2px;
          @media (min-width: 767px) {
            margin-left: 20px;
          }
          @media (max-width: 767px) {
            margin-top: 15px;
          }
        }
      }
    }
  }
}
</style>